module.exports = __webpack_public_path__ + "img/fig.5cedeb53.png";